/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSubsystemRequestDto
 */
export interface CreateSubsystemRequestDto {
    /**
     * Unique code for the subsystem
     * @type {string}
     * @memberof CreateSubsystemRequestDto
     */
    code: string;
    /**
     * Name of the subsystem
     * @type {string}
     * @memberof CreateSubsystemRequestDto
     */
    name: string;
    /**
     * Description of the subsystem
     * @type {string}
     * @memberof CreateSubsystemRequestDto
     */
    description?: string;
    /**
     * JSON schema for metadata validation
     * @type {{ [key: string]: any; }}
     * @memberof CreateSubsystemRequestDto
     */
    metadataSchema?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the CreateSubsystemRequestDto interface.
 */
export function instanceOfCreateSubsystemRequestDto(value: object): value is CreateSubsystemRequestDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateSubsystemRequestDtoFromJSON(json: any): CreateSubsystemRequestDto {
    return CreateSubsystemRequestDtoFromJSONTyped(json, false);
}

export function CreateSubsystemRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSubsystemRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'metadataSchema': json['metadataSchema'] == null ? undefined : json['metadataSchema'],
    };
}

export function CreateSubsystemRequestDtoToJSON(json: any): CreateSubsystemRequestDto {
    return CreateSubsystemRequestDtoToJSONTyped(json, false);
}

export function CreateSubsystemRequestDtoToJSONTyped(value?: CreateSubsystemRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
        'metadataSchema': value['metadataSchema'],
    };
}

